import { render } from "./FloatingMessagesWrapper.vue?vue&type=template&id=5e910ff3"
import script from "./FloatingMessagesWrapper.vue?vue&type=script&lang=js"
export * from "./FloatingMessagesWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__